import { DeclaredSchema, DeclaredSchemaProperty } from '@rossum/mdh-api-client';
import { DeclaredColumnType } from '../types';

export type DeclaredColumn = {
  label: string;
  attributeName: string;
  type: DeclaredColumnType;
};

const bsonTypes = {
  string: 'string',
  number: 'double',
  date: 'date',
  bool: 'bool',
} as const satisfies Record<
  DeclaredColumnType,
  DeclaredSchemaProperty['bson_type']
>;

// Every column is required and nullable: MDH cannot declare "no column
// required" yet (`required` is null, meaning all, or a non-empty list).
export const toDeclaredSchema = (
  columns: DeclaredColumn[]
): DeclaredSchema => ({
  bson_type: 'object',
  properties: Object.fromEntries(
    columns.map(column => [
      column.attributeName,
      { bson_type: [bsonTypes[column.type], 'null'] },
    ])
  ),
  required: null,
});

// The labels live in the dataset metadata, keyed by attribute name.
export const toColumnNames = (
  columns: DeclaredColumn[]
): Record<string, string> =>
  Object.fromEntries(
    columns.map(column => [column.attributeName, column.label])
  );
